import { paginate } from "./paginate.js";
import { iterator } from "./iterator.js";
const composePaginateRest = Object.assign(paginate, {
  iterator
});
export {
  composePaginateRest
};
